import styled from '@emotion/styled';
import { primaryFontFamily } from '../../../styles/fonts';

export const Status = styled.div<{ color: string }>`
  display: inline-block;
  background-color: ${({ theme, color }) => theme.default.colors.Status[color]};
  color: ${({ theme }) => theme.default.colors.n0};
  text-transform: uppercase;
  padding: 2px 8px;
  height: 24px;
  border-radius: 100px;

  ${primaryFontFamily}
  font-size: 14px;
  letter-spacing: 0.05em;
  line-height: 20px;
  font-weight: 500;
`;

export default Status;
